<template>
  <img class="payment-success-logo" src="../assets/logo-colored.png" />
  <h3>{{ $t("paymentSuccess.firstSentence") }}</h3>
  <br />
  <h3>{{ $t("paymentSuccess.secondSentence") }}</h3>
  <br />
  <button
    class="btn btn-primary place-row-btn place-row-verify-btn"
    @click="goBackHome()"
  >
    {{ $t("paymentSuccess.goBackBtn") }}
  </button>
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import VerificationService from "@/services/VerificationService";
const verificationService = new VerificationService();
import router from "@/router";

export default defineComponent({
  name: "PaymentSuccess",
  props: {
    paymentId: String,
  },
  setup(props) {
    console.log("props", props);
    onMounted(async () => {
      console.log("on mounted");

      const LSOwner = localStorage.getItem("owner");
      if (LSOwner == null) {
        router.replace("/login");
        return;
      }
      const parsedOwner = JSON.parse(LSOwner);

      let searchParams = new URLSearchParams(window.location.search);
      console.log("searchParams", searchParams);
      if (searchParams.has("session_id")) {
        // get session id from url
        const session_id = searchParams.get("session_id");
        console.log("session_id", session_id);

        // retrieve session from stripe

        const paymentSuccess = await verificationService.paymentSuccess(
          parsedOwner.uid,
          props.paymentId,
          session_id
        );

        console.log("paymentSuccess", paymentSuccess);

        parsedOwner.stripe_id = paymentSuccess.session.customer;
        localStorage.setItem("owner", JSON.stringify(parsedOwner));
      }
    });
  },
  methods: {
    goBackHome: () => {
      router.push(`/`);
    },
  },
});
</script>

<style></style>
